"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie;
(function (Cookie) {
    Cookie["AUTHENTICATION_COOKIE"] = "APIAUTH";
    Cookie["ANONYMOUS_SESSION_COOKIE"] = "BRID";
    Cookie["XSRF_COOKIE"] = "XSRF-TOKEN";
    Cookie["LOGOUT_INDICATOR_COOKIE"] = "USER_LOGOUT";
    Cookie["FEATURE_FLAG_OVERRIDES"] = "FEATURE-FLAG-OVERRIDES";
})(Cookie || (Cookie = {}));
exports.default = Cookie;
//# sourceMappingURL=cookies.js.map